import React, { ReactNode, useEffect } from 'react';
import { LazyMotion, domAnimation, m } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useUserContext } from 'context/UserContext';
import { useRouter } from 'next/router';
import { twMerge } from 'tailwind-merge';

const NewNavbar = dynamic(() => import('.././NewAuthNavbar'), {
  ssr: false,
  loading: () => {
    return <nav className={`flex h-[70px] w-full items-center justify-between bg-white px-5 py-2 shadow-3xl dark:bg-transparent dark:shadow-none md:px-10 md:shadow-transparent`}></nav>;
  },
});

interface IProps {
  children: ReactNode;
  className?: string;
  hideHeader?: boolean;
}

const AuthLayout = ({ children, className: customClassName, hideHeader = false }: IProps) => {
  const { token } = useUserContext();
  const router = useRouter();

  useEffect(() => {
    const authPages = ['/user/login', '/user/signup'];
    const isAuthPage = authPages.some((authPage) => router.pathname.includes(authPage));

    const { redirect } = router.query;

    if (token && isAuthPage) {
      if (redirect) {
        router.push(redirect as string);
      } else {
        router.push('/');
      }
    }
  }, [token, router]);

  return (
    <div className={twMerge('flex min-h-screen w-full', customClassName)}>
      {/* Left side (The content) */}
      <div className="relative flex flex-1 flex-col dark:bg-gradient-to-b dark:from-[#1e315c] dark:to-[#211b52]">
        {!hideHeader && <NewNavbar auth />}
        <div className="flex h-full w-full items-center justify-center">
          <div className="mx-auto w-full max-w-[450px] p-5">
            <LazyMotion features={domAnimation}>
              <m.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
              >
                {children}
              </m.div>
            </LazyMotion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
